import React, { useRef, useEffect } from 'react';

export default function AbstractArtGenerator() {
  const canvasRef = useRef(null);

  // Helper: Get a random integer between min and max
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min)) + min;

  // Helper: Get a random HSLA color string for vibrant visuals
  const getRandomColor = (alpha = 1) => {
    const h = getRandomInt(0, 360);
    const s = getRandomInt(60, 100); // High saturation for abstract pop
    const l = getRandomInt(40, 80);  // Balanced lightness
    return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
  };

  const generateArt = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    
    const width = canvas.width;
    const height = canvas.height;

    // 1. Clear previous drawings and set a background color
    ctx.fillStyle = getRandomColor(0.15); // subtle tint background
    ctx.fillRect(0, 0, width, height);

    // 2. Render random abstract shapes
    const totalShapes = getRandomInt(15, 30);

    for (let i = 0; i < totalShapes; i++) {
      ctx.save();
      ctx.fillStyle = getRandomColor(Math.random() * 0.7 + 0.2);
      ctx.strokeStyle = getRandomColor(Math.random() * 0.7 + 0.2);
      ctx.lineWidth = getRandomInt(1, 8);

      const shapeType = getRandomInt(0, 4); // Pick an abstract style branch

      switch (shapeType) {
        case 0: // Random Abstract Circles
          ctx.beginPath();
          ctx.arc(
            getRandomInt(0, width),
            getRandomInt(0, height),
            getRandomInt(10, width * 0.25),
            0,
            Math.PI * 2
          );
          Math.random() > 0.5 ? ctx.fill() : ctx.stroke();
          break;

        case 1: // Random Abstract Rectangles / Squares
          ctx.beginPath();
          ctx.rect(
            getRandomInt(0, width),
            getRandomInt(0, height),
            getRandomInt(20, width * 0.3),
            getRandomInt(20, height * 0.3)
          );
          Math.random() > 0.5 ? ctx.fill() : ctx.stroke();
          break;

        case 2: // Random Spline Lines / Bezier Curves
          ctx.beginPath();
          ctx.moveTo(getRandomInt(0, width), getRandomInt(0, height));
          ctx.bezierCurveTo(
            getRandomInt(0, width), getRandomInt(0, height),
            getRandomInt(0, width), getRandomInt(0, height),
            getRandomInt(0, width), getRandomInt(0, height)
          );
          ctx.stroke();
          break;

        case 3: // Random Triangles or Polygons
          ctx.beginPath();
          ctx.moveTo(getRandomInt(0, width), getRandomInt(0, height));
          ctx.lineTo(getRandomInt(0, width), getRandomInt(0, height));
          ctx.lineTo(getRandomInt(0, width), getRandomInt(0, height));
          ctx.closePath();
          Math.random() > 0.5 ? ctx.fill() : ctx.stroke();
          break;

        default:
          break;
      }
      ctx.restore();
    }
  };

  // Generate an initial abstract image on mount
  useEffect(() => {
    generateArt();
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', padding: '20px' }}>
      <button 
        onClick={generateArt}
        className='btn btn-primary'
      >
        Generar nueva imagen abstracta
      </button>
									<canvas 
											ref={canvasRef} 
											width={500} 
											height={500} 
											// style={{  borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
									/>
    </div>
  );
}